import { NgClass } from '@angular/common'
import { Component, EventEmitter, input, Input, Output } from '@angular/core'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'
import { ModalService } from '@app/v2/shared/services/modal.service'

@Component({
  selector: 'delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  standalone: true,
  imports: [ModalComponent, NgClass]
})
export class DeleteModalComponent {
  public confirmBtnBgColorClass = input<string>('')
  /**
   * @property id - id of the modal
   */
  @Input() id: string = 'delete-modal-id'
  /**
   * @property message - message of the delete modal
   */
  @Input() message: string = 'Are you sure you want to delete this preset?'
  /**
   * @property confirmBtnLabel - label for the confirm button
   */
  @Input() confirmBtnLabel: string = "Yes, I'm sure"
  /**
   * @property cancelBtnLabel - label for the cancel button
   */
  @Input() cancelBtnLabel: string = 'No, cancel'
  @Input() widthClass: string = 'tw-w-[480px]'
  /**
   * @emits onDelete - event when delete button is clicked
   */
  @Output() onDelete: EventEmitter<void> = new EventEmitter<void>()
  /**
   * @emits onCancel - event when cancel/close button is clicked
   */
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>()

  constructor(private _ModalService: ModalService) {}
  /**
   * @method onDeleteConfirm - emits onDelete event
   * @returns void
   */
  public onDeleteConfirm(): void {
    this.onDelete.emit()
    if (this._ModalService.isModalOpen(this.id)) this._ModalService.toggleModal(this.id)
  }

  /**
   * @method onCancelConfirm - emits onCancel so parent can close the modal
   * Called from cancel button click - parent (e.g. banner-upload-field) closes via cancelDelete()
   * @returns void
   */
  public onCancelConfirm(): void {
    this.onCancel.emit()
  }

  /**
   * @method handleModalClose - handles modal close event from X button or backdrop
   * Called from modal's onCloseModal event - modal is already closed, just emit cancel event
   * @returns void
   */
  public handleModalClose(): void {
    // Modal is already closed by the modal component, just emit the cancel event
    this.onCancel.emit()
  }
}
